import { Chip, Stack, Typography } from '@mui/material';

import { TimelineFilters } from '../timelineData';

export type TimelineAppliedFilterField =
  | 'search'
  | 'markets'
  | 'categories'
  | 'types'
  | 'species'
  | 'themes'
  | 'relevances'
  | 'dateStart'
  | 'dateEnd'
  | 'favorites';

interface TimelineAppliedFiltersProps {
  search: string;
  filters: TimelineFilters;
  onRemove: (field: TimelineAppliedFilterField, value?: string) => void;
  operationScoped?: boolean;
}

const formatFilterDate = (value: string) => {
  const [year, month, day] = value.split('-');
  return year && month && day ? `${day}/${month}/${year}` : value;
};

export default function TimelineAppliedFilters({
  search,
  filters,
  onRemove,
  operationScoped = false,
}: TimelineAppliedFiltersProps) {
  const chips: Array<{
    key: string;
    field: TimelineAppliedFilterField;
    value?: string;
    label: string;
  }> = [];

  if (search.trim()) {
    chips.push({
      key: 'search',
      field: 'search',
      label: `Busca: ${search.trim()}`,
    });
  }

  const arrayFilters: Array<{
    field:
      | 'markets'
      | 'categories'
      | 'types'
      | 'species'
      | 'themes'
      | 'relevances';
    label: string;
    values: string[];
  }> = [
    ...(!operationScoped
      ? [
          {
            field: 'markets' as const,
            label: 'Mercado',
            values: filters.markets,
          },
        ]
      : []),
    { field: 'categories', label: 'Categoria', values: filters.categories },
    { field: 'types', label: 'Tipo', values: filters.types },
    { field: 'species', label: 'Espécie', values: filters.species },
    { field: 'themes', label: 'Assunto', values: filters.themes },
    { field: 'relevances', label: 'Relevância', values: filters.relevances },
  ];

  arrayFilters.forEach(({ field, label, values }) => {
    values.forEach((value) => {
      chips.push({
        key: `${field}-${value}`,
        field,
        value,
        label: `${label}: ${value}`,
      });
    });
  });

  if (filters.dateStart) {
    chips.push({
      key: 'dateStart',
      field: 'dateStart',
      label: `De: ${formatFilterDate(filters.dateStart)}`,
    });
  }

  if (filters.dateEnd) {
    chips.push({
      key: 'dateEnd',
      field: 'dateEnd',
      label: `Até: ${formatFilterDate(filters.dateEnd)}`,
    });
  }

  if (!operationScoped && filters.favorites) {
    chips.push({
      key: 'favorites',
      field: 'favorites',
      label: 'Favoritos: Sim',
    });
  }

  if (chips.length === 0) return null;

  return (
    <Stack spacing={1} role="group" aria-label="Filtros aplicados">
      <Typography variant="body2" color="text.secondary">
        Filtros aplicados
      </Typography>
      <Stack
        direction="row"
        flexWrap="wrap"
        alignItems="center"
        sx={{ gap: 1 }}>
        {chips.map((chip) => (
          <Chip
            key={chip.key}
            label={chip.label}
            onDelete={() => onRemove(chip.field, chip.value)}
            size="small"
            variant="outlined"
          />
        ))}
      </Stack>
    </Stack>
  );
}
